import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { DELIMITER, LISTING_STATUSES, TRIGGER_LOCATIONS } from '../../constants/ClickstreamConstants';
import { trackEvent } from '../../../client/analytics';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  SPECIAL_OFFERS_ADD_NEW: '4448',
  SPECIAL_OFFERS_LEARN_MORE: '4449',
} as const;

const SPECIAL_OFFERS_CS_TRIGGER_LOCATIONS = {
  POSTING_PATH: TRIGGER_LOCATIONS.POSTING_PATH,
  POSTING_PATH_REVIEW: TRIGGER_LOCATIONS.POSTING_PATH_REVIEW,
  POSTING_PATH_REVIEW_ACTIVE_LISTING: `${TRIGGER_LOCATIONS.POSTING_PATH_REVIEW}${DELIMITER}${LISTING_STATUSES.ACTIVE}`,
  POSTING_PATH_REVIEW_OFF_MARKET_LISTING: `${TRIGGER_LOCATIONS.POSTING_PATH_REVIEW}${DELIMITER}${LISTING_STATUSES.OFF_MARKET}`,
};

// https://dataportal.zillowgroup.net/event-registry/4448
const SpecialOffersAddNew = ({
  currentProperty,
  user,
  triggerLocation = SPECIAL_OFFERS_CS_TRIGGER_LOCATIONS.POSTING_PATH,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerLocation?: (typeof SPECIAL_OFFERS_CS_TRIGGER_LOCATIONS)[keyof typeof SPECIAL_OFFERS_CS_TRIGGER_LOCATIONS];
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SPECIAL_OFFERS_ADD_NEW,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'add_offer',
    },
    semantic: {
      semantic_event_nm: 'add_special_offer',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/4449
const SpecialOffersLearnMore = ({
  currentProperty,
  user,
  triggerLocation = SPECIAL_OFFERS_CS_TRIGGER_LOCATIONS.POSTING_PATH,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerLocation?: (typeof SPECIAL_OFFERS_CS_TRIGGER_LOCATIONS)[keyof typeof SPECIAL_OFFERS_CS_TRIGGER_LOCATIONS];
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SPECIAL_OFFERS_LEARN_MORE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'button_to_learn_more',
    },
    semantic: {
      semantic_event_nm: 'add_special_offer',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

const SpecialOffersCSEvents = {
  SpecialOffersAddNew,
  SpecialOffersLearnMore,
};

// Clickstream visualizer data-eventid attributes
SpecialOffersAddNew.data_event_id = EVENT_IDS.SPECIAL_OFFERS_ADD_NEW;
SpecialOffersLearnMore.data_event_id = EVENT_IDS.SPECIAL_OFFERS_LEARN_MORE;

export default SpecialOffersCSEvents;
